// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ReferentListPagingResultModel from '../../model/referent-list-paging-result-model';
import ReferentListPagingResultDTO from '../dto/referent-list-paging-result-dto';
import dtoSchema from '../schemas/referent-list-paging-result-schema';
import ReferentListModel from '../../model/referent-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class ReferentListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ReferentListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => ReferentListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: ReferentListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<ReferentListPagingResultDTO>): ReferentListPagingResultModel;
  static toModel(dto: DeepPartial<ReferentListPagingResultDTO> | undefined | null): ReferentListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<ReferentListPagingResultDTO> | undefined | null): ReferentListPagingResultModel | undefined {
    return dto ? new ReferentListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ReferentListPagingResultModel> | ReferentListPagingResultModel): ReferentListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as ReferentListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ReferentListPagingResultModel, can not map to ReferentListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
